function animatedScrollObserver(customArg) {
    return new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {

                entry.target.classList.add(customArg);
                // Use the custom argument as needed
                // console.log('Custom argument:', customArg);

                observer.unobserve(entry.target);
            }
        });
    });
}

export default{
    bind(el, binding){
        console.log(binding.value.before_enter)
        el.classList.add(binding.value.before_enter);
        animatedScrollObserver("enter").observe(el);
    }
}
